export type StockFilterKey =
  | 'siteAssocie'
  | 'nomStock'
  | 'fournisseur'
  | 'constructeur'
  | 'statutElementStock'
  | 'etatPiece';

export const STOCK_FILTER_KEYS: StockFilterKey[] = [
  'siteAssocie',
  'nomStock',
  'fournisseur',
  'constructeur',
  'statutElementStock',
  'etatPiece',
];

export const createEmptyStockFilters = (): Record<StockFilterKey, string[]> => ({
  siteAssocie: [],
  nomStock: [],
  fournisseur: [],
  constructeur: [],
  statutElementStock: [],
  etatPiece: [],
});

export interface StockTableViewState {
  searchQuery: string;
  selectedFilters: Record<StockFilterKey, string[]>;
}

export interface StockTableView {
  id: string;
  label: string;
  isSystem?: boolean;
  state: StockTableViewState;
}

export const cloneStockTableViewState = (state: StockTableViewState): StockTableViewState => ({
  searchQuery: state.searchQuery,
  selectedFilters: STOCK_FILTER_KEYS.reduce(
    (acc, key) => {
      acc[key] = [...state.selectedFilters[key]];

      return acc;
    },
    createEmptyStockFilters(),
  ),
});
